import logo from './logo.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" style={{width: "50vw", height: "auto"}}/>
      </header>
    </div>
  );
}

export default App;
